module.exports = __webpack_public_path__ + "img/gift-icon.f30b226b.png";